import { ca } from '@cian/analytics';

export const trackDownloadOfferDoc = (id: number | undefined, position: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Click',
    action: 'download',
    label: 'doc',
    products: [
      {
        id,
        offerType: 'offer',
        position: position + 1,
      },
    ],
  });
};
